<template>
  <div style="min-height: 750px;">
    <b-row style="margin: 3px;">
      <b-col sm="12" lg="6">
        <template v-if="d_loading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </template>
        <template v-else>
          <template v-if="p_wdcCampaignClientID">
            <div v-if="p_wdcCampaignClientID">
              Client ID: <small> {{ p_wdcCampaignClientID }} </small> 
            </div>
            <div v-if="d_wdcCampaignLayerId">
              Key: <small> {{ 'L' + d_wdcCampaignLayerId + '_' + d_wdcCampaignWdmrId }} </small> 
            </div>
          </template>
          <template v-else>
            <strong>
                  {{ StoreLangTranslation.data['new_data'][StoreLang] }}
            </strong>
          </template>
        </template>

      </b-col>
      <b-col sm="12" lg="6" style="text-align: right;">
        <template v-if="!d_loading">
          <template v-if="d_saveLoading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template v-else>
            <b-button variant="outline-success" @click="f_wdcCampaignRecord()">
              {{ StoreLangTranslation.data['save'][StoreLang] }}
            </b-button>
          </template>
        </template>
      </b-col>
    </b-row>
    <b-row v-if="!d_loading" style="overflow-x: hidden; overflow-y: auto; height: 750px;">
      <b-col sm="12" lg="12">
        <b-tabs>

          <b-tab v-if="p_wdcCampaignClientID" :active="d_selectedTab === 'wdc_campaign_show'" @click="d_selectedTab = 'wdc_campaign_show'">
            <template slot="title">
              {{ StoreLangTranslation.data['wdc_campaign_show'][StoreLang] }}
            </template>
            <template v-if="d_selectedWdm && d_selectedTab === 'wdc_campaign_show'">
              <wisdom-data-show :change="change" :view_mode="'table'" :data="d_showDataModal.data" :data_type="d_showDataModal.data_type" :option_data="d_showDataModal.option_data[d_showDataModal.data_type]"></wisdom-data-show>
            </template>
          </b-tab>

          <b-tab :active="d_selectedTab === 'wdc_campaign_edit'" @click="d_selectedTab = 'wdc_campaign_edit'">
            <template slot="title">
              {{ StoreLangTranslation.data['wdc_campaign_edit'][StoreLang] }}
            </template>
            <template v-if="d_selectedWdm && d_selectedTab === 'wdc_campaign_edit'">
              <wisdom-data-modal style="overflow-y: auto; overflow-x: hidden;" :data="d_editDataModal.data" :data_type="d_editDataModal.data_type" :option_data="d_editDataModal.option_data"></wisdom-data-modal>
              <div style="max-height: 10vh;">
                <b-button @click="f_saveWdmr()" variant="success" style="float: right; margin-left: 5px;">
                  {{ StoreLangTranslation.data['save'][StoreLang] }}
                </b-button>
                <b-button @click="f_closeWdmrEditModal()" variant="danger" style="float: right;">
                  {{ StoreLangTranslation.data['cancel'][StoreLang] }}
                </b-button>
              </div>
            </template>
          </b-tab>

        </b-tabs>
      </b-col>
    </b-row>

  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import {
  default as HtmlEditor
} from '@/wam/components/widgets/HtmlEditor';
import {
  default as WisdomDataModal
} from '@/wam/components/wdmr/WisdomDataModal';
import {
  default as WisdomDataShow
} from '@/wam/components/wdmr/WisdomDataShow';
import { mapGetters } from 'vuex';
export default {
  name: 'WdcCampaignRecord',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    PageInfo,
    HtmlEditor,
    WisdomDataModal,
    WisdomDataShow,
  },
  props: {
    // p_userShopClientID: {
    //   type: String,
    //   required: true
    // },
    // p_userShopBundleClientID: {
    //   type: String,
    //   required: true
    // },
    // f_userShopBundleList: {
    //   type: Function,
    //   required: true
    // },
    f_wdcCampaignList: {
      type: Function,
      required: true
    },
    p_wdcCampaignClientID: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      d_wdcCampaignWdmrId: '',
      d_wdcCampaignLayerId: '',
      d_authorSearchLoading: false,
      d_searchAuthorMails: '',
      d_saveLoading: false,
      d_loading: false,
      d_user: '',
      d_frontendClientID: '',
      d_userShopClientID: '',
      d_userShopBundleClientID: '',
      d_frontendPackageGroupList: [],
      d_userShopBundleWdm: '',
      d_wdcCampaignData: '',
      ClsUser: ClsUser,
      d_bundleHasAgreementList: [],
      d_selectedAgreementCopy: '',
      d_agreementListLoading: false,
      d_selectBundleGroup: '',
      d_shopBundleGroupList: [],
      d_PackageGroupFrontendList: {},
      d_inputEditorMode: 'html',
      d_htmlParameters: [
        'about_dataset',
        'various_variables',
      ],
      d_authorData: {
        'firstname': '',
        'lastname': '',
        'title': '',
        'mail': '',
        'institution': {
          'tr': '',
          'en': '',
        },
        'orcid_id': '',
      },
      d_authorOldMail: '',
      d_showAuthorEditModal: false,
      d_authorUpdateLoading: false,
      d_wdcCampaignClientID: '',
      d_editDataModal: {
        'show': false,
        'data': '',
      },
      d_showDataModal: {
        'show': false,
        'data': '',
      },
      d_selectedTab: '',
      d_wdcCampaignWdm: '',
      d_selectedLayerCode: 'wdc_camp',
      d_selectedWdm: '',
      change: '0',
    };
  },
  created: function () {
    this.d_loading = true;
    ClsWdm.getLayerWdm('wdc_camp').then(resp_wdm_data => { this.d_wdcCampaignWdm = resp_wdm_data; this.d_selectedWdm = resp_wdm_data });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_userShopClientID = this.p_userShopClientID
    this.d_wdcCampaignClientID = this.p_wdcCampaignClientID
    // this.d_userShopBundleClientID = this.p_userShopBundleClientID
    // if (this.$route.query.user_shop_client_id) {
    //   this.d_userShopClientID = this.$route.query.user_shop_client_id;
    // }

    let auth_eligible = false;
    let user_perm_eligible = false;
    let user_perm_eligibleGeneral = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
      if (auth_eligible) {
        user_perm_eligible = ClsUser.f_checkUserAuth([this.d_wdcCampaignClientID + '_edit'],'with_id');
        user_perm_eligibleGeneral = ClsUser.f_checkUserAuth(['admin', 'wdc_admin']);
      }
    }
    if (this.d_user && this.d_user.username && auth_eligible && (user_perm_eligible || user_perm_eligibleGeneral) ) {
      if (this.d_wdcCampaignClientID) {
        this.f_wdcCampaignGet(); 
      } else {
        // this.f_editWdmrDocument(undefined);
      }
      this.d_loading = false;
      // if (!this.d_userShopBundleClientID) {
      //   this.f_langEligibleParameterProcess();
      //   this.d_loading = false;
      // }
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
    // this.f_getBundleHasAgreementList();
  },
  beforeMount () {},
  mounted: function () {
  },
  methods: {
    f_closeWdmrEditModal: function () {
      this.d_editDataModal.show = false;
      this.d_showDataModal.show = true;
      this.d_selectedTab = 'wdc_campaign_show';
    },
    f_saveWdmr: function () {
      // console.log('save data: ', this.d_editDataModal.data);
      let query = '';
      if (this.d_editDataModal.data['client_id']) {
        query += 'wdc_campaign_client_id=' + encodeURIComponent(this.d_editDataModal.data['client_id']);
      }
      
      let data = {
        'wdmr_data': this.d_editDataModal.data,
      };
      // console.log(query)
      // console.log(data)
      ServiceFunctions.wdc_campaign_record(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            alert("başarılı")
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_editWdmrDocument: function (row) {
      // console.log(row);
      const isNotRow = (row === undefined);  
      console.log(isNotRow)
      if (isNotRow) {
        row = {'data': {}};
        this.d_isNew = true;
      } else {
        this.d_isNew = false;
      }
      this.d_parentClientId = ''
      this.d_editDataModal.data = row;
      this.d_editDataModal.data_type = this.d_selectedLayerCode;
      this.d_editDataModal.option_data = {};
      this.d_editDataModal.option_data[this.d_selectedLayerCode] = this.d_selectedWdm;
      this.d_editDataModal.show = true;
      this.d_selectedTab = 'wdc_campaign_edit';
    },
    f_showWdmrDocument: function (row) {
      // console.log(row);
      this.d_showDataModal.data = row;
      this.d_showDataModal.data_type = this.d_selectedLayerCode;
      this.d_showDataModal.option_data = {};
      this.d_showDataModal.option_data[this.d_selectedLayerCode] = this.d_wdcCampaignWdm;
      this.d_showDataModal.show = true;
      this.d_selectedTab = 'wdc_campaign_show';
    },


    
    f_changeInputEditorMode: function(editor_mode, param_location){
      if(editor_mode == "text"){
        for (let lang of this.StoreLangList.data) {
          for (let html_param of this.d_htmlParameters) {
            let div_el = document.getElementById("website_html_edit_" + html_param + '_' + lang.label);
            param_location[html_param][lang.label] = div_el.innerHTML;
          }
        }
      }
      setTimeout(function () {
        this.d_inputEditorMode = editor_mode;
      }.bind(this), 50);
    },
    f_langEligibleParameterProcess: function () {
      let lang_eligible_variables = ['bundle_name', 'organization_id', 'organization_name', 'organization_user_id', 'organization_username', 'expiration_time_value', 'expiration_time_value_by_text', 'organization_token', 'assigned_user_list', 'special_acknowledgement_text', 'various_variables', 'about_dataset', 'methodologies_and_analyses_to_be_excluded', 'dataset_creator_note_to_requester', 'data_collection_centers'];
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          try {
            if (!this.d_wdcCampaignData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label]) {
              this.d_wdcCampaignData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
            }

          } catch {
            console.log(lang_eligible_variables[k])
          }
        }
      }
    },
    f_wdcCampaignRecord: function () {

      // try {
      //   if(this.d_inputEditorMode == 'html'){
      //     for (let lang of this.StoreLangList.data) {
      //       for (let html_param of this.d_htmlParameters) {
      //         let div_el = document.getElementById("website_html_edit_" + html_param + '_' + lang.label);
      //         this.d_wdcCampaignData[html_param][lang.label] = div_el.innerHTML;
      //       }
      //     }
      //   }
      // } catch {}
      let query = 'user_client_id=' + this.d_user.username;
      if (this.d_wdcCampaignClientID) {
        query += '&wdc_campaign_client_id=' + this.d_wdcCampaignClientID;
      }
      let data = {'wdmr_data': this.d_wdcCampaignData};
      this.d_saveLoading = true;
      ServiceFunctions.wdc_campaign_record(query, data)
        .then(resp => {
          this.d_saveLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
      if (this.d_wdcCampaignClientID) {
        this.f_wdcCampaignList();
      }
    },
    f_wdcCampaignGet: function () {
      this.d_loading = true;
      let query = 'wdc_campaign_client_id=' + this.d_wdcCampaignClientID;
      let data = {};
      ServiceFunctions.wdc_campaign_get(query, data)
        .then(resp => {
          this.d_loading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.data) {
              this.d_wdcCampaignWdmrId = resp.data.wdmr_id;
              this.d_wdcCampaignLayerId = resp.data.layer_id;
              this.d_wdcCampaignData = resp.data.data;
              this.f_showWdmrDocument(this.d_wdcCampaignData);
              // this.f_langEligibleParameterProcess();
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {
    'd_selectedWdm': function () {
      this.f_editWdmrDocument();
    }
  }
};

</script>

